export const colorGraph1 = theme => theme.colors.colorGraph1;
export const colorGraph2 = theme => theme.colors.colorGraph2;
export const colorGraph3 = theme => theme.colors.colorGraph3;
export const colorGraph4 = theme => theme.colors.colorGraph4;
export const colorGraph5 = theme => theme.colors.colorGraph5;
export const colorGraph6 = theme => theme.colors.colorGraph6;
export const colorGraph7 = theme => theme.colors.colorGraph7;
export const colorGraph8 = theme => theme.colors.colorGraph8;
export const colorKPI1 = theme => theme.colors.colorKPI1;
export const colorKPI3 = theme => theme.colors.colorKPI3;
export const colorKPI5 = theme => theme.colors.colorKPI5;
export default {
  colorGraph1,
  colorGraph2,
  colorGraph3,
  colorGraph4,
  colorGraph5,
  colorGraph6,
  colorGraph7,
  colorGraph8,
  colorKPI1,
  colorKPI3,
  colorKPI5
};
//# sourceMappingURL=colors.js.map